"use client";
import React from "react";
import { cn } from "../../utils";
import { UI_CONSTANTS } from "../../constants";

interface MenuArrowProps {
  isMenuAboveElement: boolean;
  bubblePosition: { top: number; left: number };
  isDarkMode: boolean;
  isVisible: boolean;
}

export const MenuArrow: React.FC<MenuArrowProps> = ({
  isMenuAboveElement,
  bubblePosition,
  isDarkMode,
  isVisible,
}) => {
  const menuHeight =
    document.querySelector(".element-inspector-menu")?.clientHeight ||
    UI_CONSTANTS.MENU_HEIGHT;
  // Calculate the top position based on menu position
  const topPosition = isMenuAboveElement
    ? `${bubblePosition.top + menuHeight}px` // Arrow at bottom of menu
    : `${bubblePosition.top - 8}px`; // Arrow at top of menu

  const leftPosition = `${bubblePosition.left + UI_CONSTANTS.ARROW_LEFT_OFFSET}px`;

  return (
    <div
      className={cn(
        "element-inspector-menu-arrow pointer-events-none fixed z-[10001] h-0 w-0 border-r-8 border-l-8 border-transparent transition-all duration-150",
        {
          "border-t-8": isMenuAboveElement,
          "border-b-8": !isMenuAboveElement,
          "border-t-white": isMenuAboveElement && !isDarkMode,
          "border-t-gray-800": isMenuAboveElement && isDarkMode,
          "border-b-white": !isMenuAboveElement && !isDarkMode,
          "border-b-gray-800": !isMenuAboveElement && isDarkMode,
          "opacity-0": !isVisible,
          "opacity-100": isVisible,
        },
      )}
      style={{
        top: topPosition,
        left: leftPosition,
      }}
      aria-hidden="true"
    />
  );
};
